(() => {
  if (window.__ciranovaPdpConversionLoaded) return;
  window.__ciranovaPdpConversionLoaded = true;

  const widgets = Array.from(document.querySelectorAll('[data-cn-shipping-widget]'));
  if (!widgets.length) return;

  const currency = window.Shopify?.currency?.active || 'USD';
  const locale = document.documentElement.lang || 'en-US';
  const money = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  let cartTotal = Math.max(0, Number(widgets[0].dataset.cartTotal || 0));

  function getQuantity(widget) {
    const section = widget.closest('.shopify-section') || document;
    const quantityInput = section.querySelector('input[name="quantity"]');
    return Math.max(1, Number(quantityInput?.value || 1));
  }

  function updateShippingWidget(widget) {
    const threshold = Number(widget.dataset.threshold || 0);
    const price = Number(widget.dataset.price || 0);
    if (!(threshold > 0) || !Number.isFinite(price)) return;

    const projectedTotal = cartTotal + (price * getQuantity(widget));
    const remaining = threshold - projectedTotal;
    const progress = Math.min(100, Math.max(0, (projectedTotal / threshold) * 100));
    const message = widget.querySelector('[data-cn-shipping-message]');
    const track = widget.querySelector('[data-cn-shipping-track]');
    const progressBar = widget.querySelector('[data-cn-shipping-progress]');

    widget.dataset.cartTotal = String(cartTotal);
    widget.dataset.state = remaining <= 0 ? 'unlocked' : 'progress';

    if (message) {
      message.textContent = remaining <= 0
        ? 'Free shipping included'
        : `You're ${money.format(remaining / 100)} away from free shipping`;
    }

    if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));
    if (progressBar) progressBar.style.setProperty('--cn-shipping-progress', `${progress}%`);
  }

  function updateShippingWidgets(price) {
    widgets.forEach((widget) => {
      if (Number.isFinite(price)) widget.dataset.price = String(price);
      updateShippingWidget(widget);
    });
  }

  async function refreshCartTotal() {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const cart = await response.json();
      cartTotal = Math.max(0, Number(cart.total_price || 0));
      updateShippingWidgets();
    } catch (error) {
      updateShippingWidgets();
    }
  }

  function handleVariantChange(event) {
    const variant = event?.detail?.variant;
    if (!variant) return;
    updateShippingWidgets(Number(variant.price));
  }

  // Concept dispatches this event on the product form without bubbling it.
  // Capture phase lets the shared PDP helper observe it from the document.
  document.addEventListener('variant:change', handleVariantChange, true);

  ['input', 'change'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.target?.matches?.('input[name="quantity"]')) updateShippingWidgets();
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target?.closest?.('.quantity')) return;
    window.setTimeout(() => updateShippingWidgets(), 0);
  });

  ['cart:change', 'cart:updated', 'cart:refresh'].forEach((eventName) => {
    document.addEventListener(eventName, refreshCartTotal);
  });

  updateShippingWidgets();
  refreshCartTotal();
})();
